import React, { useContext, useEffect, useState } from 'react';
import 'dotenv/config';
import useClient from '../hooks/useClient';
import { useLocation, useNavigate } from 'react-router-dom';
import config from '../config';
import Cookies from 'js-cookie';

export const UserContext = React.createContext();
export const useUserContext = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState();
  const [trustedIps, setTrustedIps] = useState([]);
  const [loginHistory, setLoginHistory] = useState([]);
  const [referrals, setReferrals] = useState([]);
  const [referralId, setReferralId] = useState();
  const [legacyId, setLegacyId] = useState();
  const [username, setUsername] = useState();
  const client = useClient();
  const navigate = useNavigate();
  const location = useLocation();

  const fetchUser = async () => {
    try {
      const res = await client.get(`${config.everywhereApi}/users/self/profile`);

      if (!res.data.data.user.verifiedEmail) {
        await client.get(`${config.everywhereApi}/users/logout`);
        Cookies.remove('_barbToken');
        setUserData();
        navigate('/login');
      }

      setUserData(res.data.data.user);
    } catch (err) {
      console.log('err', err);
      navigate('/login');
    }
  };

  const fetchTrustedIps = async () => {
    try {
      const res = await client.get(`${config.everywhereApi}/users/self/profile/trusted-ips`);

      setTrustedIps(res.data.data.trustedIps);
    } catch (err) {
      console.log('err', err);
    }
  };

  const fetchLoginHistory = async () => {
    try {
      const res = await client.get(`${config.everywhereApi}/users/self/profile/logins`);

      setLoginHistory(res.data.data.logins.reverse().slice(0, 9));
    } catch (err) {
      console.log('err', err);
    }
  };

  const fetchReferrals = async () => {
    try {
      const res = await client.get(`${config.everywhereApi}/users/self/profile/referrals`);

      setReferrals(res.data.data.referrals);
    } catch (err) {
      console.log('err', err);
    }
  };

  const handleQueryIds = async () => {
    const query = new URLSearchParams(location.search);

    const legacyId = query.get('lid');
    const referralId = query.get('referral_id');

    setLegacyId(legacyId);
    setReferralId(referralId);
  };

  useEffect(() => {
    handleQueryIds();
  }, []);

  return (
    <UserContext.Provider
      value={{
        userData,
        legacyId,
        referralId,
        setUserData,
        fetchUser,
        trustedIps,
        fetchTrustedIps,
        loginHistory,
        fetchLoginHistory,
        referrals,
        fetchReferrals,
        username,
        setUsername
      }}>
      {children}
    </UserContext.Provider>
  );
};
